/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_UploadInputs */

const en_admin_funnel_step_upload = /** @type {(inputs: Admin_Funnel_Step_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaded photo`)
};

/**
* | output |
* | --- |
* | "Uploaded photo" |
*
* @param {Admin_Funnel_Step_UploadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_upload = /** @type {((inputs?: Admin_Funnel_Step_UploadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_UploadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_upload(inputs)
});
export { admin_funnel_step_upload as "admin.funnel.step.upload" }